export class InvalidRpcError extends Error {
    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, InvalidRpcError.prototype);
        this.name = 'InvalidRpcError';
    }
}
